import { render, staticRenderFns } from "./TargetsV3.vue?vue&type=template&id=09e8ab40&scoped=true&lang=pug&"
import script from "./TargetsV3.vue?vue&type=script&lang=js&"
export * from "./TargetsV3.vue?vue&type=script&lang=js&"
import style0 from "./TargetsV3.vue?vue&type=style&index=0&id=09e8ab40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e8ab40",
  null
  
)

export default component.exports